<template>
  <v-card min-width="600" flat dense>
    <v-card-title>
      {{ dir.name }}
      <v-spacer />
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <shared-documents-list
        :documents="documents"
        hide-default-footer
        @remove="remove"
      />
    </v-card-text>
    <confirm-dialog ref="confirm" />
  </v-card>
</template>

<script>
import { PersonsService } from '@/services/persons.service';
import SharedDocumentsList from '@/modules/persons/components/SharedDocuments/SharedDocumentsList.vue';
export default {
  name: 'ViewSharedDocumentsDir',

  components: {
    SharedDocumentsList,
    ConfirmDialog: () => import('@/modules/_global/_components/ConfirmDialog')
  },

  props: {
    personId: {
      type: Number,
      required: true
    },
    dirId: {
      type: Number,
      required: true
    },
    dir: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      documents: []
    };
  },

  mounted() {
    PersonsService.getSharedDocumentsByDir({
      personId: this.personId,
      dirId: this.dirId
    }).then(({ data }) => {
      this.documents = data.data;
    });
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    },

    remove(document) {
      this.$refs.confirm
        .open(this.$t('SHARED_DOCUMENTS.REMOVE_MESSAGE'), null, {
          cancelBtnText: this.$t('BUTTON.CANCEL'),
          agreeBtnText: this.$t('BUTTON.DELETE'),
          agreeBtnColor: 'error'
        })
        .then(confirm => {
          if (confirm) {
            PersonsService.destroySharedDocument({
              personId: this.personId,
              documentId: document.id
            })
              .then(() => {
                this.documents = this.documents.filter(i => i !== document);
                this.$emit('removed', document);
              })
              .catch(console.error);
          }
        });
    }
  }
};
</script>
